import React, { createContext, useContext, useState, useRef } from "react";

type TimeContextType = {
  timelineScale: number;
  setTimelineScale: (newScale: number) => void;
} | undefined

const TimelineScaleContext = createContext<TimeContextType>(undefined);

export const TimelineScaleProvider: React.FC = ({ children }) => {
  const [timelineScale, setTimelineScaleState] = useState(65);
  const timelineScaleRef = useRef(timelineScale);
  const setTimelineScale = (newScale: number) => {
    timelineScaleRef.current = newScale; // Update the ref immediately
    setTimelineScaleState(newScale); // Update state to trigger re-renders when necessary
  };
  return (
    <TimelineScaleContext.Provider value={{ timelineScale, setTimelineScale }}>
      {children}
    </TimelineScaleContext.Provider>
  );
};

export const useTimelineScale = () => {
  const context = useContext(TimelineScaleContext);
  if (!context) throw new Error("useTime must be used within a TimeProvider");
  return context;
};
